import { PureComponent, type ReactNode } from 'react';

export type ChartProps = Readonly<{
  width: number;
  height: number;
  children: ReactNode;
  ariaLabel?: string;
  ariaDescription?: string;
}>;

export class Chart extends PureComponent<ChartProps> {
  public render() {
    const { width, height, children, ariaLabel, ariaDescription } = this.props;

    return (
      <svg
        className="Chart"
        width={width}
        height={height}
        role="img"
        aria-label={ariaLabel || 'Chart'}
        aria-describedby={ariaDescription ? 'chart-description' : undefined}
      >
        {ariaDescription && <desc id="chart-description">{ariaDescription}</desc>}
        {children}
      </svg>
    );
  }
}
